import React from 'react';
import { Typography, Stack, Paper, SxProps, Box } from '@mui/material';
import { Button } from 'system/atoms';
import { formatMsToMinutesAndSeconds } from 'utils/datetime';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { useCopyToClipboard } from '@uidotdev/usehooks';
import { ToastType, useToast } from 'services/toast';

const messageContainer: SxProps = {
  borderColor: 'customGrey.main',
  borderWidth: 1,
  borderStyle: 'solid',
  marginTop: 1,
  p: '14px'
};

const buttonContainer: SxProps = {
  display: 'flex',
  justifyContent: 'flex-start'
};

type TranscriptMessage = {
  speaker: string;
  start: number;
  end: number;
  text: string;
};

type TranscriptProps = {
  messages: TranscriptMessage[];
};

const Transcript: React.FC<TranscriptProps> = ({ messages }) => {
  const [, copyValue] = useCopyToClipboard();
  const { showToast } = useToast();

  const copyConversation = async () => {
    await copyValue(
      messages
        .map(
          (message) =>
            `${message.speaker} (${formatMsToMinutesAndSeconds(
              message.start
            )} - ${formatMsToMinutesAndSeconds(message.end)}): ${message.text}`
        )
        .join('\n\n')
    );

    showToast({
      title: 'Conversation copied to clipboard',
      type: ToastType.Success
    });
  };

  return (
    <Stack spacing={2}>
      <Stack spacing={4} maxWidth={640}>
        {messages.map((message) => (
          <Stack key={`${message.start}-${message.end}`}>
            <Stack direction="row" justifyContent="space-between">
              <Typography variant="body2">{message.speaker}</Typography>
              <Typography variant="body2">
                {formatMsToMinutesAndSeconds(message.start)} -{' '}
                {formatMsToMinutesAndSeconds(message.end)}
              </Typography>
            </Stack>

            <Paper variant="rounded" sx={messageContainer}>
              <Typography variant="body1">{message.text}</Typography>
            </Paper>
          </Stack>
        ))}
      </Stack>
      <Box sx={buttonContainer}>
        <Button
          variant="tertiary"
          startIcon={<ContentCopyIcon />}
          onClick={copyConversation}
        >
          Copy conversation
        </Button>
      </Box>
    </Stack>
  );
};

export { Transcript };
